<template>
  <div class="container diy-page">
    <v-head></v-head>
    <v-left current="email"></v-left>
    <div style="background:rgb(251,251,251)">
      <div style="position:relative;">
        <email-left :is_index_page="true" ref="email_left_ref" @get_messages_from_left="get_messages_from_left"></email-left>
        <div style="margin-left:314px;min-height:555px;background:white;">
          <div style="margin-bottom:5px;position:relative;">
            <div>
              <el-button size="mini">mark unread</el-button>
              <el-button size="mini">tag</el-button>
              <el-input placeholder="Keywords" clearable v-model="filter.keyword" class="input-with-select" style="width:499px;" size="mini">
                <el-select v-model="filter.keyword_type" slot="prepend" placeholder="Select" style="width:99px">
                  <el-option label="Auto" value="auto"></el-option>
                  <el-option label="Subject" value="subject"></el-option>
                  <el-option label="Content" value="body_content"></el-option>
                  <el-option label="Users" value="from_address"></el-option>
                </el-select>
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="search"
                ></el-button>
              </el-input>
              <!-- <el-button size="mini" type="primary" class="el-icon-s-promotion" @click="to_send"> Compose</el-button> -->
            </div>
            <div style="position:absolute;bottom:0;right:0;">
              <el-pagination
                class="my-page"
                background
                :page-size="list_data.size"
                layout="total, prev, pager, next"
                @current-change="changePage"
                :total="list_data.total"
              >
              </el-pagination>
            </div>
          </div>
          <el-table
            :data="list_data.list"
            v-loading="loading"
            border
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >   
            <el-table-column prop="id" type="selection" label="ID" width="100"></el-table-column>
            <el-table-column prop="from_name" label="From" width="255">
              <template slot-scope="scope">
                <div>
                  <h5 :class="[scope.row.is_read == 1 ? '' : 'unread-row-style']">{{ scope.row.from_address_full_name }}</h5>
                  <p class="gray-color">{{scope.row.from_address_email}}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="Subject" min-width="100">
              <template slot-scope="scope">
                <div style="position:relative;cursor:pointer;">
                  <div>
                    <h5 
                      :class="[scope.row.is_read == 1 ? '' : 'unread-row-style']" 
                      @click="to_detail(scope.row)">{{ scope.row.subject }}</h5>
                    <p class="gray-color" @click="to_detail(scope.row)">{{scope.row.summary}}</p>
                    <div v-if="scope.row.attachments.length>0" style="margin-top: 10px;">
                      <section v-for="(a, index_a) in scope.row.attachments" :key="index_a" style="display: inline-block;margin-right: 10px;">
                        <el-image
                          v-if="a.type == 'inline_image'"
                          style="width: 64px"
                          :src="a.file_oss"
                          :preview-src-list="[a.file_oss]"
                        >
                        </el-image>
                        <a v-else class="el-icon-document" style="font-size:24px;" :href="a.file_oss" target="_blank">{{a.file_name}}</a>
                      </section>
                    </div>
                  </div>
                  <div style="position:absolute;top:0;right:0;">
                    <span>{{scope.row.sent_time}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="my-page"
            background
            :page-size="list_data.size"
            layout="total, prev, pager, next"
            @current-change="changePage"
            :total="list_data.total"
          >
          </el-pagination>
        </div>
      </div>
      <component :is="activeName" :item="editItem"></component>
    </div>
  </div>
</template>
<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";
import email_left from "@/pages/email/_left";
const pop_compose = resolve => require(['@/pages/email/_pop_compose'], resolve);  

export default {
  components: {
    "v-head": head,
    "v-left": left,
    'email-left': email_left,
    pop_compose
  },
  data() {
    return {
      uid: 0,
      loading:false,
      activeName: "",
      popName: null,
      editItem:null,
      filter: {
        read_status:"",
        label_id: "",
        mailbox_email: "",
        slide_folder_account:"",
        size: 20,
        page: 1,
      },
      list_data: {
        list: [],
        size: 20,
        page: 1,
        total:0,
      },
      read_status_options:[
        {value: '', label: ''},
        {value: 'unread', label: 'Unread'},
        {value: 'read', label: 'Read'},
      ],
    };
  },
  methods: {
    handleClick(e) {
    },
    to_send() { 
      this.activeName = 'pop_compose'
    },
    to_detail(row) { 
      this.redirect('/email/detail?id=' + row.id + '&label_id=' + this.filter.label_id + "&slide_folder_account=" + this.filter.slide_folder_account)
    },
    changePage(e) { 
      this.filter.page = e;
      this.get_messages()
    },
    handleSelectionChange(e){
      console.log(e)
    },
    change_filter_read_status(){
      this.filter.page = 1;
      this.get_messages();
    },
    get_messages_from_left(e) { 
      this.filter.mailbox_email = e.mailbox_email
      this.filter.label_id = e.label_id
      this.filter.page = 1;
      this.get_messages();
    },
    search() { 
      this.page = 1;
      this.get_messages();
    },
    get_messages() {
      this.loading = true;
      this.$http
        .post("/v1/pri/store-email/messages", this.filter)
        .then((response) => {
          this.loading = false;
          var res = response.data;
          if (res.code == 1) {
            this.list_data = res.data
          }
        }).catch(() => { 
          this.loading = false;
        })
    },
  },
  mounted() {
    // this.$store.commit('set_current_menu', {name:'email'});

    var admin_password = this.getCookie("admin_password");
    if (admin_password === 'b1315E8') {
      this.uid = parseInt(localStorage.getItem("uid"));
    }
    if (this.uid != 1 && this.uid != 10000 && this.uid != 10001) { 
      return;
    }
    
    this.filter.label_id = this.getUrlParam("label_id");
    this.filter.mailbox_email = this.getUrlParam("mailbox_email");
    this.filter.slide_folder_account = this.getUrlParam("slide_folder_account");
    this.$store.dispatch("get_email_folders", {
      callback: (e) => {
      this.filter.mailbox_email = e.mailbox_email
      this.filter.label_id = e.label_id
      this.filter.page = 1;
      this.get_messages();
    }});
  }
};
</script>
<style>

.unread-row-style{font-size: 16px;font-weight: bold;color: black;}
</style>



// WEBPACK FOOTER //
// src/pages/email/Index.vue